import template from './page-detail.html';
import controller from './page.controller';
import './page.scss';

let pageComponent = {
  bindings: {},
  template,
  controller
};

export default pageComponent;



// WEBPACK FOOTER //
// ./client/app/components/page/page-privacy.component.js